import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'shared/components'

import { css } from '@emotion/core'

const NameRedirectComponent = ({ value, original, handleClickName }) => {
  const tournamentId = original.id || original.tournamentDTO?.id
  return (
    <Text
      bold
      size={11}
      css={css`
        cursor: pointer;
      `}
      onClick={() => {
        handleClickName(tournamentId)
      }}
    >
      {value}
    </Text>
  )
}

NameRedirectComponent.propTypes = {
  value: PropTypes.string,
  original: PropTypes.shape(),
  handleClickName: PropTypes.func.isRequired,
}

export default NameRedirectComponent
